module.exports = __webpack_public_path__ + "img/sd.81099f33.png";